import { render, staticRenderFns } from "./orderServicerRefuse.vue?vue&type=template&id=1f08d22e&"
import script from "./orderServicerRefuse.vue?vue&type=script&lang=ts&"
export * from "./orderServicerRefuse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports